<template>
    <div
        class="flex flex-col gap-1"
        :class="[match?.isFixed ? 'flex-col-reverse' : 'flex-col']"
    >
        <!-- INTERSTATE -->
        <div
            v-if="session.isInterstate"
            class="flex items-center gap-2"
        >
            <Lozenge
                :class="{
                    'bg-muval-purple-2 text-muval-purple-1': match.premium,
                    'bg-muval-gray-5 text-muval-gray-1': !match.premium,
                }"
                >{{ match.premium ? 'Premium' : 'Shared space' }}
                <Tippy
                    trigger="mouseenter click"
                    animation="scale"
                    placement="auto"
                >
                    <SvgIcon
                        name="system-information"
                        class="ml-1 h-4 w-4"
                    />
                    <template #content>
                        <div class="rounded-muval-2 bg-white p-4 text-sm shadow-muval-2">
                            {{
                                match.isPremium ?
                                    'Your own exclusive truck for a faster, more secure move.'
                                :   'Share a truck with other moves to save costs, with a flexible delivery window.'
                            }}
                        </div>
                    </template>
                </Tippy>
            </Lozenge>
        </div>
        <!-- LOCAL -->
        <div
            v-else
            class="flex items-center gap-2"
        >
            <template v-if="match?.pricing_type === 'FIXED' && match?.match_type === 'CUSTOM'">
                <Lozenge class="bg-muval-purple-2 text-muval-purple-1">Bespoke pricing </Lozenge>
            </template>
            <template v-else>
                <SvgIcon
                    :name="match?.pricing_type !== 'FIXED' ? 'system-two-people-outline' : 'system-deployed-code'"
                    class="h-5 w-5"
                />
                <span
                    v-if="match?.pricing_type !== 'FIXED'"
                    class="text-sm"
                >
                    {{ isFromRibbon ? numberOfMovers : 'Two' }} removalists
                </span>
                <span
                    v-else
                    class="text-sm"
                    >Cubic meter pricing</span
                >
            </template>
        </div>
        <!-- INTERSTATE -->
        <div
            v-if="session.isInterstate"
            class="flex items-center gap-2"
        >
            <SvgIcon
                name="system-truck"
                class="h-5 w-5"
            />
            <span class="text-sm"> {{ match.premium ? 'Large truck' : 'Cost effective' }}</span>
        </div>
        <!-- LOCAL -->
        <div
            v-else
            class="flex items-center gap-2"
        >
            <template v-if="match.pricing_type === 'FIXED' && match.match_type === 'CUSTOM'">
                <SvgIcon
                    name="system-two-people-outline"
                    class="h-5 w-5"
                />
                <span class="text-sm">Qualified removalists</span>
            </template>
            <template v-else>
                <SvgIcon
                    name="system-truck"
                    class="h-5 w-5"
                />
                <span class="text-sm">{{ formatTruckSize(match?.truck_size) }}</span>
            </template>
        </div>
    </div>
</template>
<script setup>
import SvgIcon from '@/components/utilities/SvgIcon.vue';
import { useSessionStore } from '@/store/session';
import { computed } from 'vue';

const session = useSessionStore();

const formatTruckSize = (size) => {
    if (!size) {
        return 'Truck';
    }

    return size.toUpperCase().charAt(0) + size.toUpperCase().slice(1).toLowerCase() + ' truck';
};

const props = defineProps({
    match: {
        type: Object,
        required: false,
        default: null,
    },
    isFromRibbon: {
        type: Boolean,
        default: false,
    },
});

const numberOfMovers = computed(() => {
    if (!props.match || typeof props.match.movers !== 'number') {
        return 'Two';
    }

    switch (props.match.movers) {
        case 2:
            return 'Two';
        case 3:
            return 'Three';
        case 4:
            return 'Four';
        default:
            return 'Two';
    }
});
</script>
